import { ProfileDetailsType } from "./ProfileDetailsType"

export type ApartmentFlagType = Pick<ProfileDetailsType, "hasApartmentFlag">

export const initialApartmentFlag: ApartmentFlagType = {
  hasApartmentFlag: null // not false as it will remove tenants on snapshot
}

export const keysOfApartmentFlagType: (keyof ApartmentFlagType)[] = [
  "hasApartmentFlag",
];